import { createSelector } from 'reselect'

const data = state => state.usuarioReducer.getIn(["nuevosUsuarios"])
export const NuevosUsuariosSelector = createSelector(
    data, (dataField) => {      
      return dataField.toJS ? dataField.toJS() : dataField
    }
  )

const dataUsuario = state => state.usuarioReducer.getIn(["usuarios"])
export const usuariosSelector = createSelector(
      dataUsuario, (dataField) => {      
        return dataField.toJS ? dataField.toJS() : dataField
      }
    )
  
const habilitado = state => state.usuarioReducer.getIn(["usuarioHabilitado"])
export const UsuarioHabilitadoSelector = createSelector(
    habilitado, (dataField) => {      
      return dataField.toJS ? dataField.toJS() : dataField
    }
  )

const usuario = state => state.usuarioReducer.getIn(["usuario"])
export const usuarioEditSelector = createSelector(
    usuario, (dataField) => {      
      return dataField.toJS ? dataField.toJS() : dataField
    }
  )
const roles = state => state.usuarioReducer.getIn(["roles"])
export const usuarioRolSelector = createSelector(
    roles, (dataField) => {      
      return dataField.toJS ? dataField.toJS() : dataField
    }
  )
  
const localidades = state => state.usuarioReducer.getIn(["localidades"])
export const localidadesSelector = createSelector(
  localidades, (dataField) => {      
      return dataField.toJS ? dataField.toJS() : dataField
    }
  )